export default __webpack_public_path__ + "70fe822d8db5b3e88d98d038843b79c8.png";